import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { loginGuard } from "./guards/login.guard";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'middle-join',
    loadChildren: () => import('./pages/middle-join/middle-join.module').then( m => m.MiddleJoinPageModule),
    canActivate:[loginGuard]
  },
  {
    path: 'register-verify-account',
    loadChildren: () => import('./pages/register-verify-account/register-verify-account.module').then( m => m.RegisterVerifyAccountPageModule)
  },
  {
    path: 'success-payment',
    loadChildren: () => import('./pages/payments-call-back/success-payment/success-payment.module').then( m => m.SuccessPaymentPageModule)
  },
  {
    path: 'failed-payment',
    loadChildren: () => import('./pages/payments-call-back/failed-payment/failed-payment.module').then( m => m.FailedPaymentPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then( m => m.MenuPageModule),
    canActivate:[loginGuard]
  },
  {
    path: 'pricing-modal',
    loadChildren: () => import('./pages/payments-call-back/pricing-modal/pricing-modal.module').then( m => m.PricingModalPageModule)
  },
  {
    path: 'recover-password',
    loadChildren: () => import('./pages/recover-password/recover-password.module').then( m => m.RecoverPasswordPageModule)
  },
  {
    path: 'modal-password',
    loadChildren: () => import('./pages/modal-password/modal-password.module').then( m => m.ModalPasswordPageModule)
  },
  {
    path: "**",
    redirectTo: "menu"
  },
  {
    path: '',
    redirectTo: 'menu/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}